import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { getFeaturedBuild } from "../../../utils/featuredBuild";
import Username from "../../Username";

function FeaturedBuildCard() {
  const [build, setBuild] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadFeaturedBuild = async () => {
      try {
        const featured = await getFeaturedBuild();
        setBuild(featured);
      } catch (error) {
        console.error("Error loading featured build:", error);
      } finally {
        setLoading(false);
      }
    };

    loadFeaturedBuild();
  }, []);

  if (loading) {
    return (
      <div style={cardStyle}>
        <div style={imagePlaceholderStyle} />
        <div style={contentStyle}>
          <p style={labelStyle}>Featured Build</p>
          <h2 style={titleStyle}>Loading...</h2>
        </div>
      </div>
    );
  }

  if (!build) {
    return null;
  }

  return (
    <Link
      to={`/user/${build.username}/car/${build.id}`}
      style={cardStyle}
    >
      <img
        src={build.image}
        alt={build.title}
        style={imageStyle}
      />

      <div style={contentStyle}>
        <p style={labelStyle}>🔥 Featured Build</p>

        <h2 style={titleStyle}>{build.title}</h2>

        <p style={usernameStyle}>by <Username username={build.username} isPro={build.ownerIsPro} /></p>

        <span style={viewStyle}>
          View Build →
        </span>
      </div>
    </Link>
  );
}

const cardStyle = {
  display: "block",
  textDecoration: "none",
  color: "white",
  backgroundColor: "#181818",
  border: "1px solid #2a2a2a",
  borderRadius: "22px",
  overflow: "hidden",
};

const imageStyle = {
  width: "100%",
  height: "260px",
  objectFit: "cover",
  display: "block",
};

const imagePlaceholderStyle = {
  height: "260px",
  background: "linear-gradient(135deg,#222,#111)",
};

const contentStyle = {
  padding: "18px",
};

const labelStyle = {
  margin: 0,
  color: "#e10600",
  fontSize: "12px",
  fontWeight: "700",
  textTransform: "uppercase",
  letterSpacing: "1px",
};

const titleStyle = {
  margin: "8px 0 6px",
  fontSize: "24px",
};

const usernameStyle = {
  margin: 0,
  opacity: 0.7,
};

const viewStyle = {
  display: "inline-block",
  marginTop: "14px",
  fontWeight: "700",
};

export default FeaturedBuildCard;
